<template>
    <header class="TheHeader">
        <div class="TheHeader-top">
            <div class="TheHeader-frame u-frameMd">
                <a href="tel:+420602711602" class="TheHeader-social">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em"
                         viewBox="100 53.006 600 493.976">
                        <path fill="currentColor"
                              d="M403.297,143.24c101.099,0.991,164.434-5.299,172.987,106.759h123.284 c0-173.595-151.397-196.993-299.481-196.993c-148.095,0-299.48,23.398-299.48,196.993h122.327 C232.398,135.806,303.038,142.26,403.297,143.24z M161.747,305.806c30.027,0,55.013,1.797,60.568-27.74 c0.747-4.015,1.179-8.565,1.179-13.829h-1.424H100C100,308.175,127.646,305.806,161.747,305.806z M577.078,264.237h-1.155 c0,5.299,0.455,9.861,1.307,13.829c5.858,27.238,30.81,25.546,60.731,25.546c34.264,0,62.039,2.253,62.039-39.375H577.078z M516.848,234.315v-17.459c0-7.808-8.997-8.298-20.107-8.298h-18.147c-11.099,0-20.096,0.49-20.096,8.298v15.043v11.67H330.125 v-11.67v-15.043c0-7.808-8.998-8.298-20.096-8.298H291.87c-11.098,0-20.096,0.49-20.096,8.298v17.459v15.241 c-29.246,30.389-124.941,159.753-128.419,175.414l0.046,104.507c0,9.651,7.854,17.505,17.505,17.505h466.808 c9.651,0,17.505-7.854,17.505-17.505V424.445c-3.442-15.206-99.114-144.512-128.372-174.9V234.315z M323.799,439.032 c-9.395,0-17.015-7.608-17.015-17.015s7.621-17.016,17.015-17.016s17.015,7.609,17.015,17.016S333.194,439.032,323.799,439.032z M323.799,380.682c-9.395,0-17.015-7.609-17.015-17.016s7.621-17.015,17.015-17.015s17.015,7.608,17.015,17.015 S333.194,380.682,323.799,380.682z M323.799,322.342c-9.395,0-17.015-7.608-17.015-17.015c0-9.395,7.621-17.015,17.015-17.015 s17.015,7.62,17.015,17.015C340.814,314.734,333.194,322.342,323.799,322.342z M393.821,439.032 c-9.395,0-17.015-7.608-17.015-17.015s7.621-17.016,17.015-17.016c9.406,0,17.015,7.609,17.015,17.016 S403.227,439.032,393.821,439.032z M393.821,380.682c-9.395,0-17.015-7.609-17.015-17.016s7.621-17.015,17.015-17.015 c9.406,0,17.015,7.608,17.015,17.015S403.227,380.682,393.821,380.682z M393.821,322.342c-9.395,0-17.015-7.608-17.015-17.015 c0-9.395,7.621-17.015,17.015-17.015c9.406,0,17.015,7.62,17.015,17.015C410.836,314.734,403.227,322.342,393.821,322.342z M463.842,439.032c-9.406,0-17.015-7.608-17.015-17.015s7.608-17.016,17.015-17.016s17.016,7.609,17.016,17.016 S473.248,439.032,463.842,439.032z M463.842,380.682c-9.406,0-17.015-7.609-17.015-17.016s7.608-17.015,17.015-17.015 s17.016,7.608,17.016,17.015S473.248,380.682,463.842,380.682z M463.842,322.342c-9.406,0-17.015-7.608-17.015-17.015 c0-9.395,7.608-17.015,17.015-17.015s17.016,7.62,17.016,17.015C480.857,314.734,473.248,322.342,463.842,322.342z"></path>
                    </svg>
                    <span>+420 602 711 602</span>
                </a>
                <a href="https://www.youtube.com/channel/UCDQfrtvhBdlzrvjwudNqLSw" target="_blank" class="TheHeader-social">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 90.676 90.678">
                        <path fill="currentColor"
                              d="M82.288,45.907c-0.938-4.071-4.268-7.074-8.275-7.521c-9.489-1.061-19.098-1.065-28.66-1.061 c-9.566-0.005-19.173,0-28.665,1.061c-4.006,0.447-7.334,3.45-8.27,7.521c-1.334,5.797-1.35,12.125-1.35,18.094 c0,5.97,0,12.296,1.334,18.094c0.936,4.069,4.264,7.072,8.272,7.521c9.49,1.061,19.097,1.065,28.662,1.061 c9.566,0.006,19.171,0,28.664-1.061c4.006-0.448,7.336-3.451,8.272-7.521c1.333-5.798,1.34-12.124,1.34-18.094 C83.61,58.031,83.62,51.704,82.288,45.907z M28.9,50.4h-5.54v29.438h-5.146V50.4h-5.439v-4.822H28.9V50.4z M42.877,79.839h-4.629 v-2.784c-1.839,2.107-3.585,3.136-5.286,3.136c-1.491,0-2.517-0.604-2.98-1.897c-0.252-0.771-0.408-1.994-0.408-3.796V54.311h4.625 v18.795c0,1.084,0,1.646,0.042,1.799c0.111,0.718,0.462,1.082,1.082,1.082c0.928,0,1.898-0.715,2.924-2.166v-19.51h4.629 L42.877,79.839L42.877,79.839z M60.45,72.177c0,2.36-0.158,4.062-0.468,5.144c-0.618,1.899-1.854,2.869-3.694,2.869 c-1.646,0-3.234-0.914-4.781-2.824v2.474h-4.625V45.578h4.625v11.189c1.494-1.839,3.08-2.77,4.781-2.77 c1.84,0,3.078,0.969,3.694,2.88c0.312,1.027,0.468,2.716,0.468,5.133V72.177z M77.907,67.918h-9.251v4.525 c0,2.363,0.773,3.543,2.363,3.543c1.14,0,1.802-0.619,2.065-1.855c0.043-0.251,0.104-1.278,0.104-3.134h4.72v0.675 c0,1.491-0.058,2.519-0.1,2.98c-0.155,1.024-0.52,1.953-1.08,2.771c-1.281,1.854-3.18,2.769-5.596,2.769 c-2.42,0-4.262-0.871-5.598-2.614c-0.981-1.278-1.486-3.29-1.486-6.003v-8.941c0-2.729,0.447-4.725,1.431-6.015 c1.336-1.747,3.177-2.617,5.54-2.617c2.32,0,4.161,0.87,5.457,2.617c0.969,1.29,1.432,3.286,1.432,6.015v5.285H77.907z M70.978,58.163c-1.546,0-2.321,1.182-2.321,3.541v2.362h4.625v-2.362C73.281,59.344,72.508,58.163,70.978,58.163z M53.812,58.163 c-0.763,0-1.534,0.36-2.308,1.125v15.56c0.772,0.773,1.545,1.14,2.308,1.14c1.334,0,2.013-1.14,2.013-3.445V61.646 C55.825,59.344,55.146,58.163,53.812,58.163z M56.396,34.973c1.705,0,3.479-1.036,5.34-3.168v2.813h4.675V8.82h-4.675v19.718 c-1.036,1.464-2.019,2.188-2.952,2.188c-0.627,0-0.994-0.37-1.097-1.096c-0.058-0.152-0.058-0.722-0.058-1.816V8.82H52.97v20.4 c0,1.821,0.155,3.055,0.413,3.836C53.854,34.363,54.891,34.973,56.396,34.973z M23.851,20.598v14.021h5.184V20.598L35.271,0h-5.242 l-3.537,13.596L22.812,0h-5.455c1.093,3.209,2.23,6.435,3.323,9.646C22.343,14.474,23.381,18.114,23.851,20.598z M42.219,34.973 c2.342,0,4.162-0.882,5.453-2.642c0.98-1.291,1.451-3.325,1.451-6.066v-9.034c0-2.758-0.47-4.774-1.451-6.077 c-1.291-1.765-3.11-2.646-5.453-2.646c-2.33,0-4.149,0.882-5.443,2.646c-0.993,1.303-1.463,3.319-1.463,6.077v9.034 c0,2.741,0.47,4.775,1.463,6.066C38.069,34.092,39.889,34.973,42.219,34.973z M39.988,16.294c0-2.387,0.724-3.577,2.231-3.577 c1.507,0,2.229,1.189,2.229,3.577v10.853c0,2.387-0.722,3.581-2.229,3.581c-1.507,0-2.231-1.194-2.231-3.581V16.294z"></path>
                    </svg>
                </a>
                <a href="https://www.facebook.com/zelenekolo" target="_blank" class="TheHeader-social">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 320 512">
                        <path fill="currentColor"
                              d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path>
                    </svg>
                </a>
            </div>
        </div>
        <div class="TheHeader-bottom">
            <div class="TheHeader-frame u-frameMd">
                <a href="https://zelenekolo.cz" class="TheHeader-logo">
                    <img src="/images/logo.png" alt="Logo - zelené kolo">
                </a>
                <MainNav/>
            </div>
        </div>
    </header>
</template>

<script>
import MainNav from './MainNav.vue';

export default {
    components: {MainNav},
    created() {
        window.addEventListener("scroll", this.stickyHeaderBottom);
    },
    unmounted() {
        window.removeEventListener("scroll", this.stickyHeaderBottom);
    },
    methods: {
        stickyHeaderBottom() {
            const mainClass = "TheHeader"
            const scrollheight = document.getElementsByClassName(mainClass + "-top")[0].offsetHeight;
            const headerBottom = document.getElementsByClassName(mainClass + "-bottom")[0];
            if (window.pageYOffset > scrollheight) {
                headerBottom.classList.add("sticky");
            } else {
                headerBottom.classList.remove("sticky");
            }
        }
    }
}
</script>

<style lang="scss">
.TheHeader {
    background: var(--colorBrandLighten);
    margin-bottom: 2rem;

    &-top {
        padding: .3em 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }

    .sticky {
        position: fixed;
        top: 0;
        z-index: 60;
        background: inherit;
        width: 100%;
        height: fit-content;

        .MainNav {
            min-height: 4.375em;
        }
    }

    &-bottom {
        position: relative;
    }

    &-frame {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    }

    &-social {
        color: #888;
        font-size: .8em;
        display: flex;
        align-items: center;
        text-decoration: none;
        margin-left: .1em;
        border-radius: 3px;
        padding: 0.4em;
        transition: all .25s ease-in-out;

        &:first-child {
            margin-right: auto;
            margin-left: 0;

            &:hover {
                color: #888;
            }
        }

        &:hover {
            color: #fff;
            text-decoration: none;
        }


        &:nth-child(2):hover {
            background: #e14f42;
        }

        &:nth-child(3):hover {
            background: #507cbe;
        }

        span {
            margin-left: .5em;
        }
    }
}
</style>